<template>
  <div id="app">
    <router-view />
    <loading-indicator />
    <modal />
    <modal-items />
    <new-version-notification />
  </div>
</template>

<script>
import { services } from '@/services'
import LoadingIndicator from '@/components/LoadingIndicator'
import Modal from '@/components/Modal'
import ModalItems from '@/components/ModalItems'
import NewVersionNotification from '@/components/NewVersionNotification'

export default {
  name: 'App',
  components: {
    LoadingIndicator,
    Modal,
    ModalItems,
    NewVersionNotification
  },
  async onIdle () {
    if (this.$route.name === 'Login') return

    this.$store.dispatch('loading/start')

    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
    this.$store.dispatch('modal/flush')
    this.$store.dispatch('items/disable')

    const data = this.$store.getters['user/status']
    const service = services.userService(data)
    await service.logout()

    this.$store.dispatch('user/flush')
    this.$store.dispatch('loading/stop')
    this.$router.push({ name: 'Login' })
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue